import { useState } from "react";
import CustomPagination from "../../../../helper/Pagination";
import Spinner from "../../../../Components/spinner";
import { formatDate } from "../../../../utils/constants";
import {
 checkImage,
 DeleteSingleButton,
 StockCheckbox,
 ToggleSwitch,
} from "../../../../helper/ImageFormat";

const SearchCatalogueTable = ({
 loading,
 productData,
 currentPage,
 perPage,
 handleDelete,
 handleStatusToggle,
 handleStockToggle,
 totalCount,
 totalPages,
 handlePageClick,
}) => {
 const [openRow, setOpenRow] = useState(null);

 const toggleRow = (id) => {
  setOpenRow(openRow === id ? null : id);
 };

 return (
  <div className="row">
   <div className="col-md-12">
    <div className="card">
     <div className="card-body">
      <div className="table-responsive">
       <table className="custom-table table table-striped">
        <thead>
         <tr>
          <th>Image</th>
          <th>Name</th>
          <th>Code</th>
          <th>Price</th>
          <th>Products</th>
          <th>Status</th>
          {/* <th>Stock</th> */}
          <th>Action</th>
         </tr>
        </thead>

        <tbody>
         {loading ? (
         <tr>
  <td colSpan="8" className="text-center py-5">
    <div className="d-flex justify-content-center align-items-center">
      <Spinner />
    </div>
  </td>
</tr>
         ) : productData?.length > 0 ? (
          productData.map((cat) => (
           <>
            {/* Catalogue Row */}

            <tr key={cat.id}>
             <td>{checkImage(cat.coverImage)}</td>

             <td>{cat.name}</td>

             <td>{cat.cat_code}</td>

             <td>{cat.price}</td>

             <td>
              <button
               className="count-button1"
               onClick={() => toggleRow(cat.id)}
              >
               {cat.no_of_product}
              </button>
             </td>

             <td>
              <ToggleSwitch
               data={cat}
               name="isActive"
               checked={cat.isActive}
               handleStatusToggle={handleStatusToggle}
               module="catalogue"
              />
             </td>

             {/* <td>
              <StockCheckbox
               data={cat}
               checked={cat.outofStock}
               handleStockToggle={handleStockToggle}
              />
             </td> */}

             <td>
              <DeleteSingleButton item={cat} handleDelete={handleDelete} />
             </td>
            </tr>

            {/* Products Expand Row */}

            {openRow === cat.id && cat.products?.length > 0 && (
             <tr>
              <td colSpan="8">
               <table className="table">
                <thead>
                 <tr>
                  <th>Image</th>
                  <th>Name</th>
                  <th>SKU</th>
                  <th>Price</th>
                  <th>Status</th>
                  <th>Out of Stock</th>
                  <th>Action</th>
                 </tr>
                </thead>

                <tbody>
                 {cat.products.map((product) => (
                  <tr key={product.id}>
                   <td>{checkImage(product.image?.[0])}</td>

                   <td>{product.name}</td>

                   <td>{product.sku}</td>

                   <td>{product.retail_price}</td>

                   <td>
                    <ToggleSwitch
                     data={product}
                     name="isActive"
                     checked={product.isActive}
                     handleStatusToggle={handleStatusToggle}
                     module="Products"
                    />
                   </td>

                   <td>
                    <StockCheckbox
                     data={product}
                     checked={product.outofStock}
                     handleStockToggle={handleStockToggle}
                    />
                   </td>

                   <td>
                    <DeleteSingleButton
                     item={product}
                     handleDelete={handleDelete}
                    />
                   </td>
                  </tr>
                 ))}
                </tbody>
               </table>
              </td>
             </tr>
            )}
           </>
          ))
         ) : (
          <tr>
           <td colSpan="8" className="text-center">
            No data available
           </td>
          </tr>
         )}
        </tbody>
       </table>
      </div>

      {productData?.length > 0 && (
       <CustomPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageClick}
        perPage={perPage}
        totalCount={totalCount}
       />
      )}
     </div>
    </div>
   </div>
  </div>
 );
};

export default SearchCatalogueTable;
